/**
 * Залипшая цена: сколько нога стоит без движения и стоит ли об этом говорить.
 *
 * Самая дорогая слепота зеркальной ленты. Замер 06.08 по донору: 58.9 % ног не
 * двигались дольше 150 секунд, и верх списка по проценту — это ровно они.
 * Механика простая: настоящую вилку рынок съедает за секунды, поэтому чем
 * дольше цена стоит, тем выше шанс, что её уже нет — просто донор ещё не узнал.
 * Человек ставит первую ногу, идёт за второй и обнаруживает, что второй нет.
 *
 * Почему предупреждение, а не фильтр. Прятать такие строки нельзя: часть из них
 * настоящие (мелкая контора действительно не переставляла цену), и сняв их все,
 * мы бы отдали конкуренту весь прематч. Решение принимает человек — но принимает
 * его ЗНАЯ, а сейчас он не знает вовсе: поле `still` доезжает с сервера и не
 * показывается нигде.
 *
 * Пороги взяты из наблюдаемого поведения, а не из красивых чисел.
 *
 *   live      150 с — по этой границе снят замер выше; в живой линии цена
 *                     переставляется десятками раз в минуту, и две с половиной
 *                     минуты покоя означают, что за ней никто не следит;
 *   прематч   900 с — линия до начала стоит на порядок дольше законно, и
 *                     единая мерка объявила бы залипшей половину нормального
 *                     прематча.
 *
 * `sure` отделено намеренно. Часть меток — нижняя граница («стоит НЕ МЕНЬШЕ
 * стольки»), потому что мы наблюдаем ногу с момента, как её увидели, а не с
 * момента, как её выставили. Сказать «стоит 300 с» там, где известно только
 * «не меньше 300», значит подставить измерение вместо догадки.
 */

/** Порог покоя, за которым цена перестаёт быть свежей. Секунды. */
export const STILL_LIVE = 150;
export const STILL_PREMATCH = 900;

/** Честные окна ЦУПИС. Остальным — общий live, не 15 с Вилки. */
export const STILL_LIVE_BY_SOURCE: Readonly<Record<string, number>> = {
  fonbet: 70,
  zenit: 60,
  winline: 35,
  leon: 60,
  betboom: 30,
  olimp: 25,
};

export function stillLimit(source: string, live: boolean): number {
  if (!live) return STILL_PREMATCH;
  return STILL_LIVE_BY_SOURCE[source] ?? STILL_LIVE;
}

export function stillDeadSeconds(window: number): number {
  return Math.max(2 * window, 30);
}

/**
 * Красное «могут не принять» на полике и предикте.
 *
 * Обычный `stillness` для конторы — это час котировки: мелкий бук может не
 * переставлять цену и всё равно принять ставку. На полике тот же покой значит
 * другое: стакан на экране ещё рисуется, а ордера уже не принимает
 * (`trading is disabled`). Антон 19.09 поставил вторую ногу в БК, полик отказал,
 * сканер молчал: 18 мин и 43 мин без движения висели мелкой строкой у ссылки,
 * в красный блок `stale`/`frozen` специально не пускают.
 *
 * 10 минут, не 150 с живой линии. Середина стакана полика может стоять пару
 * минут при живых ордерах — орать «не примут» на каждом таком тике нельзя.
 * Десять минут без тика на CLOB — уже зомби. Строку не прячем: человек решает,
 * но решает ЗНАЯ.
 */
export const STILL_SHARE = 600;

const SHARE_BOOK: Readonly<Record<string, 'polymarket' | 'predictfun'>> = {
  poly: 'polymarket',
  polymarket: 'polymarket',
  predictfun: 'predictfun',
};

export function shareBookOf(source: string): 'polymarket' | 'predictfun' | null {
  return SHARE_BOOK[source.trim().toLowerCase()] ?? null;
}

export function shareStillSay(source: string): string {
  return shareBookOf(source) === 'predictfun'
    ? 'предикт молчит, могут не принять'
    : 'полик молчит, могут не принять';
}

export interface Stillness {
  /** Сколько стоит самая залипшая нога, секунды. */
  seconds: number;
  /** Площадка этой ноги. */
  source: string;
  /** Измерено точно или это нижняя граница («не меньше»). */
  sure: boolean;
}

const num = (value: unknown): number | null =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

/**
 * Секунды, прошедшие у нас с момента получения строки.
 *
 * Без этого слагаемого вся защита молчит ровно там, где она нужна. Сервер шлёт
 * покой один раз и не обновляет его каждую секунду (иначе вся лента уезжает
 * клиенту раз в секунду — те самые десятки килобайт), а строка, у которой цена
 * ЗАСТЫЛА, не меняется больше ничем и обновления не получает вовсе. Прими мы
 * серверное число как есть — «стоит 12 с» осталось бы на экране и через час
 * покоя. Двинулась цена — придёт новая строка со свежим нулём и новым `at`.
 */
const since = (fork: Record<string, unknown>, now: number | undefined): number => {
  const at = num(fork.at);
  if (at === null || now === undefined) return 0;
  return Math.max(0, Math.floor((now - at) / 1000));
};

/**
 * Самая залипшая нога строки — или `null`, если тревожить не о чем.
 *
 * `null` возвращается и тогда, когда покой НЕ ИЗМЕРЕН: строка без метки
 * времени цены не «свежая», она неизвестная, и рисовать на этом месте
 * успокаивающую пустоту честнее, чем выдуманное число. Молчание здесь не
 * обещает свежести — его обещает только зелёная надпись, которой у нас нет.
 *
 * `now` — часы клиента в миллисекундах. Без него покой считается ровно тем,
 * что прислал сервер: так ведут себя вызовы, у которых своих часов нет, и
 * ошибаются они в сторону молчания, а не выдуманной тревоги.
 */
export function stillness(fork: Record<string, unknown>, now?: number): Stillness | null {
  const live = fork.line === 'live';
  const worst = standing(fork, now);
  if (worst === null) return null;
  const limit = stillLimit(worst.source, live);
  return worst.seconds >= limit ? worst : null;
}

/**
 * Самая долго стоящая нога — без порога, просто число.
 *
 * Отдельно от `stillness`, потому что вопросы разные. Тот отвечает «тревожно
 * ли», а полке полувилок нужно ровно «сколько»: коридор живёт стоящей ценой, и
 * тревога там была бы на каждой строке, то есть ни на одной.
 */
export function standing(fork: Record<string, unknown>, now?: number): Stillness | null {
  const legs = Array.isArray(fork.legs) ? (fork.legs as Record<string, unknown>[]) : [];
  const listed = Array.isArray(fork.still) ? fork.still : [];
  const grown = since(fork, now);

  let worst: Stillness | null = null;
  for (let i = 0; i < legs.length; i += 1) {
    const leg = legs[i]!;
    // Сервер шлёт покой двумя видами: на ноге и массивом на вилке, в том же
    // порядке что `legs`. Читать только ногу — молчать, когда доехала только
    // пачка (карточка Belkovics 21.08 рисовала «жива» при стоячих 55¢).
    const measured = num(leg.still) ?? num(listed[i]);
    if (measured === null) continue;
    const seconds = measured + grown;
    if (worst !== null && seconds <= worst.seconds) continue;
    worst = {
      seconds,
      source: typeof leg.s === 'string' ? leg.s : '—',
      sure: leg.stillSure !== false,
    };
  }
  return worst;
}

/** Покой одной площадки — для плитки, не «худшая из двух». */
export function stillOf(
  fork: Record<string, unknown>,
  source: string,
  now?: number,
): Stillness | null {
  const legs = Array.isArray(fork.legs) ? (fork.legs as Record<string, unknown>[]) : [];
  const listed = Array.isArray(fork.still) ? fork.still : [];
  const grown = since(fork, now);
  for (let i = 0; i < legs.length; i += 1) {
    const leg = legs[i]!;
    if (leg.s !== source) continue;
    const measured = num(leg.still) ?? num(listed[i]);
    if (measured === null) return null;
    return {
      seconds: measured + grown,
      source,
      sure: leg.stillSure !== false,
    };
  }
  return null;
}

/**
 * Замерший полик или предикт — повод остановить руку, не снять строку.
 *
 * Смотрит только биржевые ноги. Если хуже замер Фонбет, а полик живой —
 * красного нет. Если хуже Фонбет, а полик тоже мёртв — красное про полик.
 */
export function shareStill(fork: Record<string, unknown>, now?: number): Stillness | null {
  const legs = Array.isArray(fork.legs) ? (fork.legs as Record<string, unknown>[]) : [];
  const listed = Array.isArray(fork.still) ? fork.still : [];
  const grown = since(fork, now);
  let worst: Stillness | null = null;
  for (let i = 0; i < legs.length; i += 1) {
    const leg = legs[i]!;
    const source = typeof leg.s === 'string' ? leg.s : '';
    if (shareBookOf(source) === null) continue;
    const measured = num(leg.still) ?? num(listed[i]);
    if (measured === null) continue;
    const seconds = measured + grown;
    if (seconds < STILL_SHARE) continue;
    if (worst !== null && seconds <= worst.seconds) continue;
    worst = { seconds, source, sure: leg.stillSure !== false };
  }
  return worst;
}

/** Дольше этого возраста записи фраза «живёт N с» врёт: N — не свежесть цены. */
export const LIFE_AS_UPDATE_AFTER = 10 * 60;

/** Подпись возраста. До 10 минут — «живёт». Дальше — когда обновлялась цена. */
export function lifePhrase(
  age: number,
  fork: Record<string, unknown>,
  now?: number,
  lifespan: number | null = null,
): string {
  if (age > LIFE_AS_UPDATE_AFTER) {
    const stood = standing(fork, now);
    if (stood !== null) {
      const n = Math.max(0, Math.round(stood.seconds));
      return stood.sure ? `обновлено ${n} с назад` : `обновлено не меньше ${n} с назад`;
    }
  }
  return lifespan !== null ? `живёт ${age}/${lifespan} с` : `живёт ${age} с`;
}

/** Покой словами: минуты вместо трёхзначных секунд, «не меньше» для догадки. */
export function stillText(one: Stillness): string {
  const body =
    one.seconds >= 120 ? `${Math.round(one.seconds / 60)} мин` : `${Math.round(one.seconds)} с`;
  return one.sure ? body : `не меньше ${body}`;
}
